



















































import Vue from 'vue';
import {mapActions, mapGetters} from "vuex";

export default Vue.extend({
  name: 'Login',
  data() {
    return {
      email: "",
      password: "",
    }
  },
  computed: {
    ...mapGetters('account', [
      'isLoading',
    ]),
  },
  methods: {
    ...mapActions('account', ['login']),
    onLogin() {
      this.login({ email: this.email, password: this.password})
        .then(() => this.$router.push({ name: 'projects'}))
    },
  }
});
